
  import { defineComponent } from 'vue';

  import ContextMenu from '@/common/components/redesigned/ContextMenu/ContextMenu.vue';
  import ContextMenuItem from '@/common/components/redesigned/ContextMenu/ContextMenuItem.vue';

  import { LocalContextMenuActions } from './types';

  export default defineComponent({
    name: 'LocalContextMenu',
    components: {
      ContextMenu,
      ContextMenuItem,
    },
    props: {
      isVisible: {
        type: Boolean,
        default: false,
      },
      position: {
        type: Object as () => { top: number; left: number },
        required: true,
      },
      isShowChildrenActions: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['action', 'close'],
    methods: {
      handleClose() {
        this.$emit('close');
      },

      handleSelectAll() {
        this.handleAction(LocalContextMenuActions.SELECT_ALL);
      },

      handleUnselectAll() {
        this.handleAction(LocalContextMenuActions.UNSELECT_ALL);
      },

      handleExpandAll() {
        this.handleAction(LocalContextMenuActions.EXPAND_ALL);
      },

      handleCollapseAll() {
        this.handleAction(LocalContextMenuActions.COLLAPSE_ALL);
      },

      handleSelectAllChildren() {
        this.handleAction(LocalContextMenuActions.SELECT_ALL_CHILDREN);
      },

      handleUnselectAllChildren() {
        this.handleAction(LocalContextMenuActions.UNSELECT_ALL_CHILDREN);
      },

      handleSelectAllChildrenByLevel() {
        this.handleAction(LocalContextMenuActions.SELECT_ALL_CHILDREN_BY_LEVEL);
      },

      handleUnselectAllChildrenByLevel() {
        this.handleAction(LocalContextMenuActions.UNSELECT_ALL_CHILDREN_BY_LEVEL);
      },

      handleAction(action: LocalContextMenuActions) {
        this.$emit('action', action);
        this.$emit('close');
      },
    },
  });
